<template>
  <c-button left-icon="location" @click="onDHLLocatorClick">
    {{ label }}
  </c-button>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { CButton } from "@chakra-ui/vue";
import { mapState } from "vuex";
import { SubsidiaryIds } from "@iloq/shared";

export default defineComponent({
  components: {
    CButton,
  },
  props: {
    label: {
      type: String,
      required: true,
    },
    countryCode: {
      type: String,
      required: true,
    },
    zipCode: {
      type: String,
      required: true,
    },
  },
  computed: mapState({
    user: (state) => state.user,
  }),
  methods: {
    onDHLLocatorClick() {
      const { countryCode, languageCode, subsidiaryId } = this.user;
      const measurements = subsidiaryId === SubsidiaryIds.USA ? "mi" : "km";
      const url = `https://locator.dhl.com/results?language=${languageCode}&languageCountryCode=${countryCode}&resultUom=${measurements}&light=n&countryCode=${this.countryCode}&clientAppCode=gspl&address=${this.zipCode}&capability=81,74`;
      window.open(url, "_blank");
    },
  },
});
</script>
